<template>
  <div class="card-ads-horizontal noselect p-1" :class="advertisement.top_ad == 1 ? 'top-ads-border' : ''">
    <div class="photo-container">
      <NuxtLink :to="{ name: 'oglas-title-id', params: { title: advertisement.slug || $srbTolat.srbTolat(advertisement.title), id: advertisement.id } }">
        <div class="photo">
          <NuxtImg
            :src="$getImageSrc(advertisement?.img)"
            fit="cover"
            width="60"
            height="60"
            loading="lazy"
            :alt="advertisement?.title + ' – pregled cena na pijacama'"
            class="img-ads-br img-fluid"
          />
          <div
            v-if="advertisement.duration_days < 0"
            class="inactive-ads-img sell-inactive-ads-left-h"
          >
            istekao
          </div>
          <div
            v-if="advertisement.status == 'sold'"
            class="sell-ads-img sell-inactive-ads-left-h"
            :class="advertisement.duration_days < 0 ? 'sell-ads-top-inactive' : ''"
          >
            prodat
          </div>
        </div>
      </NuxtLink>
    </div>

    <div class="description">
      <div class="row-h-1">
        <div class="title-h">
          <NuxtLink :to="{ name: 'oglas-title-id', params: { title: advertisement.slug || $srbTolat.srbTolat(advertisement.title), id: advertisement.id } }">
            <h2>{{ advertisement.title }}</h2>
          </NuxtLink>
        </div>

        <div class="heart-h heart-h-circle text-end" @click="onToggleFollow">
          <i
            class="esei icon-heart heart ml-1"
            :class="useStoreCustomer.loggedIn && followed ? 'place-icon-color-ads-follower' : 'place-icon-color-ads'"
          ></i>
        </div>

        <div class="category-h">
          <div class="category-text">{{ advertisement.category_name ? `${advertisement.category_name} - ${advertisement.subcategory_name}` : advertisement.subcategory_name }}</div>
        </div>
      </div>

      <NuxtLink :to="{ name: 'oglas-title-id', params: { title: advertisement.slug || $srbTolat.srbTolat(advertisement.title), id: advertisement.id } }">
        <div class="row-h-2">
          <div class="place">
            <p>
              <i class="esei icon-map-marker place-icon-color-ads font-size-10"></i>
              {{ advertisement.place_name }}
            </p>
          </div>
          <div class="view">
            <p>viđen: <span class="font-weight-bold">{{ advertisement.views_count }}</span></p>
          </div>
        </div>

        <div class="row-h-3">
          <div class="col-1-h mt-2 text-end">
            <div class="del text-start">
             <span class="adr-tz adr-tz-solo" v-if="advertisement?.lawyer == 1"><i class="esei icon-store-solid" aria-hidden="true"></i>Tezga</span>  
    
              <p class="font-size-11"> {{advertisement?.trade_type === 'buy' ? 'KUPUJEM' : ''}}</p>
            </div>
          </div>

          <div class="col-2-h mt-2 text-end">
            <div class="price-h text-end">
              <div class="price-text text-uppercase">
                {{ displayPrice(advertisement?.price_type, advertisement?.price) }}
                <span>{{ currencySymbol(advertisement.price_type, advertisement.currency_code) }}</span>
              </div>
            </div>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
import { useNuxtApp } from '#app'
import { useCustomerLoginStore } from '~/stores/login/customer'

const { $srbTolat } = useNuxtApp()
const useStoreCustomer = useCustomerLoginStore()

const props = defineProps({
  advertisement: { required: true, type: Object },
  errorValidation: Object,
  displayBtn: { type: Boolean, default: true },
})

// shared composables (iste kao u ostalim komponentama)
const { displayPrice, currencySymbol } = usePriceFormat()
const { followed, syncFollowedFromFollowers, toggleFollow } = useAdFollowers()

const onToggleFollow = async () => {
  if (!props.advertisement?.id) return
  await toggleFollow(props.advertisement.id)
}

// inicijalno + kad se promeni user ili follower lista
watch(
  () => [props.advertisement?.follower_id, useStoreCustomer.customer?.id],
  () => syncFollowedFromFollowers(props.advertisement?.follower_id),
  { immediate: true }
)
</script>
